// Generated by scripts/build-content-index.ts. Do not edit by hand.

import publishedReading0Json from "../readings/visitor-at-midnight.json";
import publishedReading1Json from "../readings/the-reconciliation.json";
import publishedReading2Json from "../readings/the-cost-of-being-clear.json";
import publishedReading3Json from "../readings/any-other-business.json";
import publishedReading4Json from "../readings/the-last-key.json";
import publishedReading5Json from "../readings/the-apprentice-of-bells.json";
import publishedReading6Json from "../readings/the-second-interview.json";
import publishedReading7Json from "../readings/the-night-auction.json";
import publishedReading8Json from "../readings/a-defence-of-idleness.json";
import publishedReading9Json from "../readings/the-weight-of-an-empty-frame.json";
import initialLessonLexiconJson from "./lesson-lexicons/visitor-at-midnight.json";
import type { LessonLexicon, Reading } from "../types";

export const MAINTAINED_READING_REGISTRATIONS = [
  {
    id: "visitor-at-midnight",
    fileName: "visitor-at-midnight.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
  {
    id: "the-reconciliation",
    fileName: "the-reconciliation.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
  {
    id: "the-cost-of-being-clear",
    fileName: "the-cost-of-being-clear.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
  {
    id: "any-other-business",
    fileName: "any-other-business.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
  {
    id: "the-last-key",
    fileName: "the-last-key.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
  {
    id: "the-bench-on-wardle-green",
    fileName: "the-bench-on-wardle-green.json",
    edition: "2026-07-16.3",
    editorialState: "in_review",
  },
  {
    id: "the-cartographers-only-lie",
    fileName: "the-cartographers-only-lie.json",
    edition: "2026-07-16.2",
    editorialState: "in_review",
  },
  {
    id: "letters-to-the-next-keeper",
    fileName: "letters-to-the-next-keeper.json",
    edition: "2026-07-16.2",
    editorialState: "in_review",
  },
  {
    id: "naming-the-birds",
    fileName: "naming-the-birds.json",
    edition: "2026-07-16.2",
    editorialState: "in_review",
  },
  {
    id: "eulogy-by-a-rival",
    fileName: "eulogy-by-a-rival.json",
    edition: "2026-07-16.2",
    editorialState: "in_review",
  },
  {
    id: "the-audible-lie",
    fileName: "the-audible-lie.json",
    edition: "2026-07-16.2",
    editorialState: "in_review",
  },
  {
    id: "the-apprentice-of-bells",
    fileName: "the-apprentice-of-bells.json",
    edition: "2026-07-26.1",
    editorialState: "published",
  },
  {
    id: "the-second-interview",
    fileName: "the-second-interview.json",
    edition: "2026-07-26.1",
    editorialState: "published",
  },
  {
    id: "the-night-auction",
    fileName: "the-night-auction.json",
    edition: "2026-07-26.2",
    editorialState: "published",
  },
  {
    id: "a-defence-of-idleness",
    fileName: "a-defence-of-idleness.json",
    edition: "2026-07-26.2",
    editorialState: "published",
  },
  {
    id: "the-ninth-return",
    fileName: "the-ninth-return.json",
    edition: "2026-07-17.3",
    editorialState: "in_review",
  },
  {
    id: "the-weight-of-an-empty-frame",
    fileName: "the-weight-of-an-empty-frame.json",
    edition: "2026-07-16.1",
    editorialState: "published",
  },
] as const;

export const GENERATED_PUBLISHED_READING_IDS = [
  "visitor-at-midnight",
  "the-reconciliation",
  "the-cost-of-being-clear",
  "any-other-business",
  "the-last-key",
  "the-apprentice-of-bells",
  "the-second-interview",
  "the-night-auction",
  "a-defence-of-idleness",
  "the-weight-of-an-empty-frame",
] as const;

export const GENERATED_PUBLISHED_READINGS: Reading[] = [
  publishedReading0Json as Reading,
  publishedReading1Json as Reading,
  publishedReading2Json as Reading,
  publishedReading3Json as Reading,
  publishedReading4Json as Reading,
  publishedReading5Json as Reading,
  publishedReading6Json as Reading,
  publishedReading7Json as Reading,
  publishedReading8Json as Reading,
  publishedReading9Json as Reading,
];

export const GENERATED_INITIAL_READING_ID = "visitor-at-midnight";
export const GENERATED_INITIAL_LESSON_LEXICON = initialLessonLexiconJson as LessonLexicon;

export const GENERATED_LESSON_LEXICON_LOADERS: Readonly<Record<string, () => Promise<LessonLexicon>>> = {
  "visitor-at-midnight": () => Promise.resolve(GENERATED_INITIAL_LESSON_LEXICON),
  "the-reconciliation": () =>
    import("./lesson-lexicons/the-reconciliation.json")
      .then((module) => module.default as LessonLexicon),
  "the-cost-of-being-clear": () =>
    import("./lesson-lexicons/the-cost-of-being-clear.json")
      .then((module) => module.default as LessonLexicon),
  "any-other-business": () =>
    import("./lesson-lexicons/any-other-business.json")
      .then((module) => module.default as LessonLexicon),
  "the-last-key": () =>
    import("./lesson-lexicons/the-last-key.json")
      .then((module) => module.default as LessonLexicon),
  "the-apprentice-of-bells": () =>
    import("./lesson-lexicons/the-apprentice-of-bells.json")
      .then((module) => module.default as LessonLexicon),
  "the-second-interview": () =>
    import("./lesson-lexicons/the-second-interview.json")
      .then((module) => module.default as LessonLexicon),
  "the-night-auction": () =>
    import("./lesson-lexicons/the-night-auction.json")
      .then((module) => module.default as LessonLexicon),
  "a-defence-of-idleness": () =>
    import("./lesson-lexicons/a-defence-of-idleness.json")
      .then((module) => module.default as LessonLexicon),
  "the-weight-of-an-empty-frame": () =>
    import("./lesson-lexicons/the-weight-of-an-empty-frame.json")
      .then((module) => module.default as LessonLexicon),
};
